module.exports = __webpack_public_path__ + "assets/img/shop_img.d0cb7f8c.png";